<div class="avd-code-example">
    <div class="avd-code-example__label">
        @if (storybookLink || repoLink) {
            <div class="avd-code-example__links">
                @if (storybookLink) {
                    <a
                        class="avd-code-example__link"
                        [href]="storybookLink"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Storybook
                    </a>
                }
                @if (repoLink) {
                    <a
                        class="avd-code-example__link"
                        [href]="repoLink"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Repo
                    </a>
                }
            </div>
        }
        <h3>{{ label }}</h3>
        @if (description) {
            <p>{{ description }}</p>
        }
    </div>

    <div
        class="avd-code-example__preview"
        [class.avd-code-example__preview--no-padding]="noPadding"
    >
        <ng-content></ng-content>
    </div>

    <div class="avd-code-example__toggle">
        <button uilabMatButton="text" (click)="toggleCode()">
            {{ showCode ? 'Hide code' : 'Show code' }}
        </button>
    </div>

    @if (showCode) {
        <div class="avd-code-example__code-panel">
            @if (activeTab === 'html') {
                <pre
                    class="avd-code-example__pre"
                ><code [highlight]="htmlSnippet" [language]="'html'"></code></pre>
            }
        </div>
    }
</div>
